import React, { useEffect, useState } from "react";
// import { PunchingButton } from "../../components/punchinButton";
import { TakeSnap } from "./TakeSnap";
import toast from "react-hot-toast";
import usePut from "../../hooks/put/usePut";
import { useNavigate } from "react-router-dom";
// import { MdOutlineFitScreen } from "react-icons/md";
import ScreenCapture from "./ScreenCapture";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import L from "leaflet";
import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet";
import { Button } from "../../components/ui";
import InlineLoader from "../../components/loader/InlineLoader";
import LocationBlockedCard from "../../components/location/LocationBlockedCard";

// Fix for Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

/*
const mapStyles = {
  height: "30vh",
  width: "100%",
};
*/


// Component to recenter map and fix tile alignment when coordinates change
function ChangeView({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center, zoom);
    // This fixes the 'grey area' and miscentering issues on load
    setTimeout(() => {
      map.invalidateSize();
    }, 100);
  }, [center, zoom, map]);
  return null;
}

const MarkWFHAttendanceForm = () => {
  const [isLocationDenined, setIsLocationDenined] = useState(0);
  const navigate = useNavigate();
  const [isLocationFetched, setIsLocationFetched] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [zoom, setZoom] = useState(16);
  const [coordinates, setCoordinates] = useState({
    lat: 19.0760,
    lng: 72.8777,
  });

  // const { isLoaded } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: "AIzaSyCYBAbuZ0pN5BkdsJDJ__-3ysfkl5QjdfM", // HRMS KEY
  // });

  const requestLocationAccess = () => {
    setIsRequesting(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { coords } = position;
        const data = {
          lat: coords?.latitude,
          lng: coords?.longitude,
        };
        setZoom(16);
        setCoordinates(data);
        setIsLocationFetched(true);
        setIsLocationDenined(0);
        setIsRequesting(false);
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          setIsLocationDenined(1);
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          toast.error("Location information is unavailable. Please check your GPS or internet connection.");
        } else if (error.code === error.TIMEOUT) {
          toast.error("Location request timed out. Please try again.");
        } else {
          console.error("Error getting location:", error);
        }
        setIsRequesting(false);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  useEffect(() => {
    // Silently check permission status without prompting
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then((status) => {
        if (status.state === 'granted') {
          requestLocationAccess();
        } else if (status.state === 'denied') {
          setIsLocationDenined(1);
        }

        // Automatically fetch or update UI if user changes settings
        status.onchange = () => {
          if (status.state === 'granted') {
            requestLocationAccess();
            setIsLocationDenined(0);
          } else if (status.state === 'denied') {
            setIsLocationDenined(1);
          }
        };
      });
    } else {
      // Fallback for older browsers: We wait for user interaction to prompt
    }
  }, []);
  /*
  const markerOnLoad = (marker) => {
    // console.log('marker: ', marker)
  };
  */
  const { handleAuth } = usePut({
    url: "punch_in",
    // url: "user_check_in",
    onSuccess: (res) => {
      toast.success("Attendance added successfully");
      setTimeout(() => {
        navigate("/");
      }, [2000]);
    },
    onError: (err) => {
      const { status, data } = err?.response || {};
      if (status >= 400 || status <= 499) {
        toast.error(data?.message || "Something went wrong");
      } else {
        toast.error("Internal server error");
      }
    },
  });
  // const [map, setMap] = useState(null);
  const [uploadedImage, setUploadedImage] = useState({});
  const [screenCapture, setScreenCapture] = useState(null);
  const handleSubmitPunch = () => {
    // console.log(uploadedImage, screenCapture);

    if (!uploadedImage?.image_id) {
      toast.error("Please add picture of yourself");
      return;
    }
    if (!screenCapture?.image_id) {
      toast.error("Please add picture of work screen");
      return;
    }
    let data = {
      image_id: uploadedImage?.image_id,
      screen_image_id: screenCapture?.image_id,
      lat: coordinates?.lat,
      long: coordinates?.lng,
      punch_type: "WFH",
    };
    console.log(data);
    handleAuth.mutate(data);
  };

  /*
  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(coordinates);
    map.fitBounds(bounds);
    setMap(map);
  }, [coordinates]);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  const mapStyles = {
    height: "30vh",
    width: "100%",
  };
  */


  return (
    <div className="px-5 pt-10">
      <h1 className=" text-xl font-semibold pb-6">
        Marking Attendance for Remote Work{" "}
      </h1>
      <ul>
        <li>
          <small>
            <b>Step 1:</b> If you are working from home today, please mark your
            attendance by clicking on the button below.
          </small>
        </li>
        <li>
          <small>
            <b>Step 2:</b> Take a screen capture.
          </small>
        </li>
        <li>
          <small>
            <b>Step 3:</b> Take a Snap of your face.
          </small>
        </li>
      </ul>

      <div className="mt-8">
        {isLocationDenined ? (
          <LocationBlockedCard />
        ) : (
          <div style={{ height: "30vh", width: "100%" }}>
            <MapContainer
              center={[coordinates.lat, coordinates.lng]}
              zoom={zoom}
              style={{ height: "100%", width: "100%" }}
            >
              <ChangeView
                center={[coordinates.lat, coordinates.lng]}
                zoom={zoom}
              />
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[coordinates.lat, coordinates.lng]} />
            </MapContainer>
            {/* {isLoaded ? (
                <GoogleMap
                  mapContainerStyle={mapStyles}
                  center={coordinates}
                  zoom={zoom}
                  onLoad={onLoad}
                  onUnmount={onUnmount}
                >
                  <Marker
                    visible={true}
                    position={coordinates}
                    onLoad={markerOnLoad}
                  />
                </GoogleMap>
              ) : (
                <></>
              )} */}
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-4 space-y-4 md:space-y-0 md:space-x-4 mt-10 md:mt-20">
          <div>
            <ScreenCapture setScreenCapture={setScreenCapture} />
          </div>
          <div>
            <TakeSnap setUploadedImage={setUploadedImage} />
          </div>
        </div>

        <div className=" my-5 text-center">
          {isLocationDenined ? (
            <Button onClick={requestLocationAccess}>
              Grant Location Access
            </Button>
          ) : (
            <Button
              disabled={isRequesting}
              onClick={
                isLocationFetched ? handleSubmitPunch : requestLocationAccess
              }
            >
              {isRequesting ? (
                <div className="flex items-center gap-2">
                  <InlineLoader />{" "}
                  <span className="text-xs">Fetching Location...</span>
                </div>
              ) : isLocationFetched ? (
                "Mark Attendance"
              ) : (
                "Get Location"
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarkWFHAttendanceForm;
